module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-tw/banner1-e89c850d97299a73f16e15a36018f854.jpg";